import React, { createContext, useState, useEffect } from "react";
import { lightColors, darkColors } from "../constants/Colors.js";

export const AppDataContext = createContext();

const AppDataProvider = ({ children }) => {
  const [globalSettings, setGlobalSettings] = useState([]);

  const [articleStateTypes, setArticleStateTypes] = useState([]);
  const [tags, setTags] = useState([]);
  const [articles, setArticles] = useState([]);
  const [categories, setCategories] = useState([]);
  const [slideshows, setSlideshows] = useState([]);

  const [isLoggedIn, setLoggedIn] = useState(false);
  /**
   * This refers to the "Allow unregistered access" setting.
   */
  const [isForceLogin, setForceLogin] = useState(false);
  const [isDarkMode, setDarkMode] = useState(false);

  useEffect(() => {}, [
    articleStateTypes,
    globalSettings,
    tags,
    articles,
    categories,
    slideshows,
    isLoggedIn,
    isDarkMode,
    isForceLogin,
  ]);

  // CATEGORIES
  const setCategoriesList = (category) => {
    setCategories(category);
  };

  // Useful for updating local lists (when we add new categories)
  const appendCategoriesList = (category) => {
    var newArray = categories.slice();
    newArray.push(category);
    setCategoriesList(newArray);
  };

  // TAGS
  const setTagsList = (article) => {
    setTags(article);
  };

  // Useful for updating local lists (when we add new tags)
  const appendTagsList = (article) => {
    var newArray = tags.slice();
    newArray.push(article);
    setTagsList(newArray);
  };

  // ARTICLES
  const setArticleList = (article) => {
    setArticles(article);
  };

  // For local usage
  const appendArticleList = (article) => {
    var newArray = articles.slice();
    newArray.push(article);
    setArticleList(newArray);
  };

  // SLIDESHOWS
  const setSlideshowList = (article) => {
    setSlideshows(article);
  };

  // For local usage
  const appendSlideshowList = (article) => {
    var newArray = slideshows.slice();
    newArray.push(article);
    setSlideshows(newArray);
  };

  // ARTICLE STATE TYPES
  const setArticleStateTypeList = (article) => {
    setArticleStateTypes(article);
  };

  /**
   * Useful when we add a state type - shows it locally too.
   */
  const appendArticleStateTypeList = (article) => {
    var newArray = articleStateTypes.slice();
    newArray.push(article);
    setArticleStateTypeList(newArray);
  };

  const saveGlobalSettingsMany = (article) => {
    setGlobalSettings(article);
  };

  const saveGlobalSetting = (article) => {
    const newArticle = {
      id: article.id,
      settingId: article.settingId,
      description: article.description,
      value: article.value,
    };
    var newArray = globalSettings.slice();
    newArray.push(newArticle);
    setGlobalSettings(newArray);
  };

  return (
    <AppDataContext.Provider
      value={{
        globalSettings,

        saveGlobalSetting,
        saveGlobalSettingsMany,

        /* Article States (draft, sponsored, live etc) */
        articleStateTypes,
        setArticleStateTypeList,
        appendArticleStateTypeList,

        /* Tags (e.g. funny, serious etc) */
        tags,
        setTagsList,
        appendTagsList,

        /* Categories (e.g. News, slideshow etc) */
        categories,
        setCategoriesList,
        appendCategoriesList,

        /* Articles (e.g. funny, serious etc) */
        articles,
        setArticleList,
        appendArticleList,

        /* Slideshows (e.g. funny, serious etc) */
        slideshows,
        setSlideshowList,
        appendSlideshowList,

        /* Logged in or not */
        isLoggedIn,
        setLoggedIn,

        /* Allow guests */
        isForceLogin,
        setForceLogin,

        /** Dark mode */
        isDarkMode,
        setDarkMode,
        colors: isDarkMode ? darkColors : lightColors,
      }}
    >
      {children}
    </AppDataContext.Provider>
  );
};

export default AppDataProvider;
